/**
 * Author(s) : Durga Bogada
 * Purpose : This is the Recap page to show previous years 
 */

import React from "react";
import PropTypes from "prop-types";
import * as DOMPurify from 'dompurify';

const RecapPage = ({path}) => {
    let pageInfo = DOMPurify.sanitize(require(`/${path}`));
    return (
        <div>{pageInfo}</div>
    )
}

export default RecapPage;
RecapPage.propTypes = {
    path : PropTypes.string.isRequired
}